import React from "react";
import { ExportButton } from "components/buttons";
import { EmissionsAllocationExportRequestBody, exportEmissionsAllocationSummary } from "api";

export const ExportCSVButton = ({ query }: { query: EmissionsAllocationExportRequestBody }) => (
    <ExportButton
        exportFunction={exportEmissionsAllocationSummary}
        exportParams={query}
        exportText="Export CSV"
        exportingText="Exporting CSV..."
        successMessage="CSV exported successfully."
        isZipFile={false}
        exportTitle="emissions-allocation-summary"
        sx={{
            borderRadius: "8px",
            width: '204px',
            height: '36px',
            fontWeight: 500
        }}
    />
);